import {Component} from '@angular/core';
import {Router, ActivatedRoute} from '@angular/router';
import {Location} from '@angular/common';
import {AlertService, ResolvePlanService} from '../_services';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';
import {PlanFormAbstractComponent} from "./plan-form-abstract.component";

@Component({
  moduleId: module.id.toString(),
  templateUrl: './resolve-plan-edit.component.html'
})
export class ResolvePlanNewComponent extends PlanFormAbstractComponent {
  constructor(
    protected router: Router,
    protected location: Location,
    protected route: ActivatedRoute,
    protected planService: ResolvePlanService,
    protected formBuilder: FormBuilder,
    protected alertService: AlertService
  ) {
    super(router, location, route, planService, alertService);
    this.isNew = true;
    this.objectName = 'Resolve Plan';
  }

  protected buildForm(): FormGroup {
    return this.formBuilder.group({
      name: [null, Validators.required],
      description: [null],
      subscription_rate: [null, [Validators.required, Validators.min(0)]],
      included_lookups: [null, [Validators.required, Validators.min(0)]],
      lookup_fee: [null, [Validators.required, Validators.min(0)]],
      included_sessions: [null, [Validators.required, Validators.min(0)]],
      crm_action_fee: [null, [Validators.required, Validators.min(0)]],
      is_active: [false],
    });
  }
}
